/**
 * Credits per US dollar: ONE. Owner decision 2026-09-20, settled and
 * stateable ("we agreed $1 = 1cred"). The platform's margin is in the PRICE
 * of each service, never in an opaque exchange rate: every platform LLM charge
 * in the ledger is exactly 1.4000x the recorded provider cost (507 charges,
 * every model, checked before the decision), and that multiplier is
 * `MODEL_RETAIL_MULTIPLIER`. So the rate itself is public, and the old rule
 * "never state a credits-to-dollars rate" is retired.
 *
 * This module holds the number and nothing else, on purpose. It has no
 * imports and nothing mocks it, so it can be read from three places that
 * cannot share any other module:
 *
 *   - lib/platform/settings.ts, where `rewards.basisCreditsPerUsd` defaults
 *     to it (the 2026-08-08 rewards-basis decision, same number);
 *   - lib/email/templates/layout.ts and app/api/admin/earnings/grants/route.ts,
 *     where it is the ONLY permitted fallback when that setting cannot be
 *     read. Until 2026-09-20 both fell back to a stale 100, so an unreadable
 *     or zeroed setting would have mailed a $50 Creator Fund grant as
 *     "5,000 credits";
 *   - lib/balance/units.ts, whose `toCredits` multiplies by it.
 *
 * Twenty unit suites factory-mock `@/lib/balance/units` with a partial export
 * list, and vitest throws on access of a missing export from such a mock; a
 * constant that settings.ts read from units.ts at module load would have
 * broken every one of them. Hence its own file.
 *
 * Unchanged by this, and still regulatory (CLAUDE.md, credits section;
 * docs/internal/launch/tos-review-credits-and-eu.md §21.1-21.4): Service
 * Credits are not transferable and are never withdrawn (Creator Rewards are
 * a separate object), and no user pays another. Robutler is the principal.
 */
export const CREDITS_PER_USD = 1;
